import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M16.0001 1.59998V7.99998M30.4001 16H24.0001M8.0001 16H1.6001M16.0001 24V30.4M27.2001 16C27.2001 22.1856 22.1857 27.2 16.0001 27.2C9.81454 27.2 4.80012 22.1856 4.80012 16C4.80012 9.81439 9.81454 4.79998 16.0001 4.79998C22.1857 4.79998 27.2001 9.81439 27.2001 16Z" />
  </svg>
);
